/**
 * System: Geschosse.
 *
 * Zuständigkeit: Flugbahn, Treffer und Ablauf von Geschossen — in beide
 * Richtungen. Schaden geht durch `kampf.ts`.
 */

import { TAKT_DAUER } from '@pg/protocol';
import type { Geschoss, Welt } from '../typen.js';
import type { Ctx } from './typen.js';
import { begehbar } from '../karte.js';
import { schadenAmSpieler, trefferAufGegner } from './kampf.js';
import { abstandQ } from '../vektor.js';

export function geschosse(welt: Welt, ctx: Ctx): void {
  const s = welt.spieler;
  const krit = ctx.zufall.strom('kritisch');

  for (const p of welt.geschosse) {
    if (p.tot) continue;
    p.pos.x += p.gesch.x * TAKT_DAUER;
    p.pos.y += p.gesch.y * TAKT_DAUER;
    p.verbleibend -= TAKT_DAUER;

    if (p.verbleibend <= 0 || !begehbar(welt.karte, p.pos.x, p.pos.y)) {
      p.tot = true;
      continue;
    }

    if (p.vomSpieler) {
      for (const g of welt.gegner) {
        if (g.tot) continue;
        if (abstandQ(p.pos, g.pos) > (p.radius + g.radius) ** 2) continue;
        trefferAufGegner(welt, ctx, g, p.schaden, krit, null);
        p.tot = true;
        break;
      }
    } else if (!s.tot && abstandQ(p.pos, s.pos) <= (p.radius + s.radius) ** 2) {
      schadenAmSpieler(welt, ctx, p.schaden, 'wucht');
      p.tot = true;
    }
  }

  for (let i = welt.geschosse.length - 1; i >= 0; i--) {
    if ((welt.geschosse[i] as Geschoss).tot) welt.geschosse.splice(i, 1);
  }
}
